<template>
    <b-container fluid>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <div>
        <filtros-busqueda :empleados.sync="empleados"
                          @buscar="buscarDatosDesempenio"
                          :tipo-busqueda="tipoBusqueda" />
        <b-button @click="exportarExcel()" :disabled="!excel" variant="info">Exportar Excel</b-button>
      </div>
      <div>
        <b-alert  variant="success"
                  show
        >
          <span style="margin-right: 40%;"  v-b-tooltip.hover
                title="Para información mas detallada sobre los tratamientos, verifique la pestaña de 'Reporte de productividad' "
          >Total tratamientos Realizados: {{totalTratamientosPonderacion}} </span>
          <span style="margin-right: 1%;" >Total a recibir: {{totalPagoArecibir | moneda}} </span>
        </b-alert>
      </div>
    <div class="container">

      <br/>
        <div class="col">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datos"
              :fields="columnas"
              :per-page="$registrosPorPagina"
              :current-page="paginaActual"
              stacked="md"
              responsive
              class="parrafos"
          >
          <template v-slot:cell(fechaTratamiento)="row">
            {{ row.item.fechaTratamiento|formatoFechaCorta }}
          </template>
          </b-table>

          <b-pagination
              v-if="datos !== undefined && datos.length > 10"
              align="center"
              v-model="paginaActual"
              :total-rows="datos.length"
              :per-page="$registrosPorPagina"
          ></b-pagination>

          <b-spinner v-if="loader" variant="primary" ></b-spinner>

        </div>

    </div>
      <br/>
      <br/>
      <br/>
  </b-container>
</template>
<script>
import FiltrosBusqueda from "@/components/Compensaciones/FiltrosBusqueda";
import XLSX from 'xlsx';
export default{
  components: {FiltrosBusqueda},
  props: {
        empleados: Array
    },
    data(){
        return{
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,
          loader: false,
          quincena: null,
          especialidad: null,
          idEmpleado: null,
          totalPagoArecibir: 0,
          datos:[],
          columnas:[
            {key: "fechaCaluloFechaProgramada", label: "Fecha", sortable: true},
            {key: "especialidad", label: "Especialidad", sortable: true},
            {key: "clinica", label: "Clínica", sortable: true},
            {key: "metaProductividad", label: "Objetivo", sortable: true},
            {key: "monto", label: "Pago", sortable: true},
          ],
          paginaActual:1,
          tipoBusqueda: "quincena",
          totalTratamientosPonderacion: 0.0,
          excel: false,
          filtros: null
        }
    },
    created() {
      this.debug = this.$localStorageService.getDebug();
      if (this.$localStorageService.can('Com_01_cambio')) {
        this.columnas.push({key: "nombreDoctor", label: "Empleado", sortable: true});
      }
    },
    methods: {
      exportarExcel(){
        const doctor = this.empleados.find(element => element.idEmpleado == this.filtros.idEmpleado);
        const fecha = this.$moment(new Date()).format('l')
      const newDate = fecha.split("/")
      var dia = newDate[0];
      var mes = newDate[1];
      var anio = newDate[2];

       

      let datosExcel = [];
       this.datos.forEach((element) => {
          let datos = {
            "Nombre empleado": doctor.nombreDoctor,
            "Fecha de sesión": this.$moment(element.fechaCaluloFechaProgramada).format('DD/MM/YYYY'),
            "Especialidad realizado a px": element.especialidad,
            "Clínica": element.clinica,
            "Objetivo": element.metaProductividad,
            "Pago": "$ " + element.monto,
        }

        if (this.$localStorageService.can('Com_01_cambio')) {
           datos["Empleado"] = element.nombreDoctor;
        }

        datosExcel.push(datos);
       
       });

       datosExcel.push("");
       datosExcel.push( {
           "Total tratamientos realizados": this.totalTratamientosPonderacion,
           "Total pago a recibir": "$ " + this.totalPagoArecibir
        });
       let data = XLSX.utils.json_to_sheet(datosExcel)
      const workbook = XLSX.utils.book_new()
      const filename = 'bono_desempeño_'+dia+'_'+mes+'_'+anio;
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
      },
        buscarDatosDesempenio(filtro) {
          this.paginaActual = 1;
          this.filtros = filtro;
          this.excel = false;
        this.loader = true
          this.datos = [];
          this.totalPagoArecibir = 0.0
          this.totalTratamientosPonderacion = 0.0

        this.$http.post(this.$api + 'comisiones/comision_bloque/empleado/bonoDesempenio', filtro).then(respuesta => {
            if (respuesta.data.data) {
              let data = respuesta.data.data;
              this.datos = data.detalleDesempenio;
              this.totalPagoArecibir = data.totalPagoBono;
              this.totalTratamientosPonderacion = data.totalTratamientosPonderacion;
            }
            this.excel = true;
        }).finally(() => {
              this.loader = false;
            })
        }
    }
}
</script>
<style>
#h1{
    text-align: center;
    font-size: 25px;
    color: rgb(80, 180, 220);
    font-weight: bold;
}
#tablaIzquierda{
    float: left;
    padding: 10px;
    width: 300px;
    margin: 20px;
}
#tablaDerecha{
    float: left;
    padding: 10px;
    width: 300px;
    margin: 20px;
    margin-left: 200px;
}
</style>